module.exports = __webpack_public_path__ + "img/12_of_Clubs.svg.974ebb56.png";